// extracted by mini-css-extract-plugin
export default {"badge":"VerifiedBadge_badge__UcfXZ","emoji":"VerifiedBadge_emoji__QkryO","label":"VerifiedBadge_label__ftx1L"};